import * as React from "react";
import { forwardRef } from "react";
const SvgTrace = (props, ref) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	width: "1em",
	height: "1em",
	ref,
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	x: 10.6,
	y: 15,
	width: 11.7,
	height: 3,
	rx: .42
}), /* @__PURE__ */ React.createElement("rect", {
	x: 17.8,
	y: 20,
	width: 7.2,
	height: 3,
	rx: .42,
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("rect", {
	x: 7,
	y: 10,
	width: 18,
	height: 3,
	rx: .42,
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	fill: "currentColor",
	d: "M31 0h1v2h-1zM0 0h1v2H0zm31 3h1v2h-1zM0 3h1v2H0zm31 3h1v2h-1zM0 6h1v2H0zm31 3h1v2h-1zM0 9h1v2H0zm31 3h1v2h-1zM0 12h1v2H0zm31 3h1v2h-1zM0 15h1v2H0zm31 3h1v2h-1zM0 18h1v2H0zm31 3h1v2h-1zM0 21h1v2H0zm31 3h1v2h-1zM0 24h1v2H0zm31 3h1v2h-1zM0 27h1v2H0zm31 3h1v2h-1zM0 30h1v2H0z"
}));
const ForwardRef = forwardRef(SvgTrace);
export default ForwardRef;
